import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdvancedFilterModel } from '../models/AdvancedFilterModel';
import { LookupModel } from '../../common/models/LookupModel';
import { MatDialogRef, MatOption, MatSelect, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { UserService } from '../../customer/services/UserService';
import { JobsService } from '../services/JobsService';
const selectAllOption = 'SelectAll';

@Component({
  selector: 'brd-advanced-filter-dialog',
  templateUrl: './advanced-filter-dialog.component.html',
  styleUrls: ['./advanced-filter-dialog.component.scss']
})
export class AdvancedFilterDialogComponent implements OnInit {
  filterForm: FormGroup;
  dataWarehouseService: any;
  statuses: LookupModel[];
  submittingEntities: LookupModel[];
  users: LookupModel[];
  dataSets: LookupModel[];
  countCollection: LookupModel[] = [{ key: '0', description: 'Count = 0' }, { key: '1', description: 'Count > 0' }];

  constructor(
    public dialogRef: MatDialogRef<AdvancedFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private jobService: JobsService
  ) {
    var model = this.data.model;
    if (model == null) {
      this.filterForm = this.formBuilder.group({
        submitters: [''],
        users: [''],
        beginDate: null,
        endDate: null,
        datasetTypes: [''],
        status: [''],
        successful: [''],
        errors: [''],
        warnings: ['']
      });
    } else {
      this.filterForm = this.formBuilder.group({
        submitters: [model.submitters],
        users: [model.users],
        beginDate: [model.beginDate],
        endDate: [model.endDate],
        datasetTypes: [model.datasetTypes],
        status: [model.status],
        successful: [model.successful],
        errors: [model.errors],
        warnings: [model.warnings]
      });
    }
  }

  ngOnInit() {
    this.userService.getCurrentUserSubmittingEntities().subscribe(result => {
      this.submittingEntities = result.model;
    });
    this.userService.getCurrentUserUsers().subscribe(result => {
      this.users = result.model;
    });
    this.jobService.getJobStatuses().subscribe(result => {
      this.statuses = result.model;
    });
    this.jobService.getJobDataSets().subscribe(result => {
      this.dataSets = result.model;
    });
  }

  search(): void {
    this.dialogRef.close(this.processSelectAll(this.filterForm.value));
  }

  processSelectAll(model: AdvancedFilterModel) {
    if (model != null) {
      model.datasetTypes = this.handleSelectAll(model.datasetTypes);
      model.errors = this.handleSelectAll(model.errors);
      model.status = this.handleSelectAll(model.status);
      model.submitters = this.handleSelectAll(model.submitters);
      model.successful = this.handleSelectAll(model.successful);
      model.users = this.handleSelectAll(model.users);
      model.warnings = this.handleSelectAll(model.warnings);
    }

    return model;
  }

  private handleSelectAll(array: LookupModel[]): any[] {
    if(!array) {
      return [];
    }
    return array.find(t => t.key === 'SelectAll') ? [] : array;
  }

  lookupCompare (l1: LookupModel, l2: LookupModel) {
    return l1 && l2 ? l1.key === l2.key : l1 === l2;
  }

  selectAll(option: MatOption,select: MatSelect) {
    if (option.selected) {
      select.options.forEach( o => {
        o.select();
      });
    } else {
      select.options.forEach( o => {
        o.deselect();
      });
      select.writeValue([]);
    }
  }

  onStatusSelection(controlName: string, dataSource: LookupModel[], allSelected: MatOption): void {
    if (allSelected.selected) {
      allSelected.deselect();
      let statusObject = this.filterForm.controls[controlName].value as LookupModel[];
      let index = statusObject.findIndex(x => x.key === selectAllOption);
      if (index > -1) {
        statusObject.splice(index, 1);
      }
      this.filterForm.controls[controlName].patchValue([...statusObject.map(item => item)]);
      return;
    }
    if (this.filterForm.controls[controlName].value.length === dataSource.length) {
      allSelected.select();

      let statusObject = this.filterForm.controls[controlName].value as LookupModel[];
      let index = statusObject.findIndex(x => x.key === selectAllOption);
      if (index == -1) {
        this.filterForm.controls[controlName].patchValue([...dataSource.map(item => item), { key: selectAllOption }]);
      }
    }
  }

  toggleSelectAll(controlName: string, dataSource: LookupModel[], allSelected: MatOption) {
    if (allSelected.selected) {
      this.filterForm.controls[controlName].patchValue([...dataSource.map(item => item), { key: selectAllOption }]);
    } else {
      this.filterForm.controls[controlName].patchValue([]);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/submission/components/advanced-filter-dialog.component.ts